import { Box, useTheme } from "@mui/material";

import { RobotoTypography } from "@/shared/components";
import { Goto } from "@/shared/navigation/Goto";

import { SettingsPageLayout } from "../SettingsPageLayout";

import { IntegrationCard } from "./IntegrationCard";
import { FoxgloveIcon, S3Icon, SlackIcon } from "./IntegrationIcon";

export function Integrations() {
  const theme = useTheme();

  return (
    <SettingsPageLayout>
      <RobotoTypography variant="body1" sx={{ mb: 3 }}>
        Connect Roboto with your favorite tools and services to streamline your
        robotics data workflows.
      </RobotoTypography>

      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: {
            xs: "1fr",
            sm: "repeat(auto-fit, minmax(350px, 1fr))",
          },
          gap: theme.spacing(3),
          mt: 2,
        }}
      >
        <IntegrationCard
          name="AWS S3"
          description="Connect your existing S3 bucket to store and manage your robotics data."
          status="available"
          href={Goto.route.S3Integration}
          icon={<S3Icon size={40} />}
        />

        <IntegrationCard
          name="Foxglove"
          description="Automatically import and process robotics data from your Foxglove recordings."
          status="available"
          href={Goto.route.FoxgloveIntegration}
          icon={<FoxgloveIcon size={40} />}
        />

        {/* "Available" here means the route exists, not that this viewer can use it. The card
            shows unconditionally, and the page behind it is optimistic in three ways: on a
            deployment with no Slack app bootstrapped the first query (GET /v1/slack/connections
            raises when the feature is unconfigured) fails and the page opens on an error alert;
            a non-admin gets the read-only view, because connect/disconnect/allowlist are
            ORG_ADMIN_ONLY; and a non-premium org cannot connect at all, since the server
            premium-gates connect and allowlist writes. Wiring the card to a real capability
            probe is future work. */}
        <IntegrationCard
          name="Slack"
          description="Let Roboto agents post updates to Slack channels your team approves."
          status="available"
          href={Goto.route.SlackIntegration}
          icon={<SlackIcon size={40} />}
        />
      </Box>
    </SettingsPageLayout>
  );
}
